import React from "react";

export const SipIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.17157 4.17157C2 5.34315 2 7.22876 2 11V11.25H22V11C22 7.22876 22 5.34315 20.8284 4.17157C19.6569 3 17.7712 3 14 3H10C6.22876 3 4.34315 3 3.17157 4.17157ZM22 12.75H2V13C2 16.7712 2 18.6569 3.17157 19.8284C4.34315 21 6.22876 21 10 21H14C17.7712 21 19.6569 21 20.8284 19.8284C22 18.6569 22 16.7712 22 13V12.75ZM5.25 17.5C5.25 17.9142 5.58579 18.25 6 18.25C6.41421 18.25 6.75 17.9142 6.75 17.5V15.5C6.75 15.0858 6.41421 14.75 6 14.75C5.58579 14.75 5.25 15.0858 5.25 15.5L5.25 17.5ZM9 18.25C8.58579 18.25 8.25 17.9142 8.25 17.5V15.5C8.25 15.0858 8.58579 14.75 9 14.75C9.41421 14.75 9.75 15.0858 9.75 15.5V17.5C9.75 17.9142 9.41421 18.25 9 18.25ZM13.5 15.75C13.0858 15.75 12.75 16.0858 12.75 16.5C12.75 16.9142 13.0858 17.25 13.5 17.25H18C18.4142 17.25 18.75 16.9142 18.75 16.5C18.75 16.0858 18.4142 15.75 18 15.75H13.5ZM9 9.25C8.58579 9.25 8.25 8.91421 8.25 8.5V6.5C8.25 6.08579 8.58579 5.75 9 5.75C9.41421 5.75 9.75 6.08579 9.75 6.5V8.5C9.75 8.91421 9.41421 9.25 9 9.25ZM5.25 8.5C5.25 8.91421 5.58579 9.25 6 9.25C6.41421 9.25 6.75 8.91421 6.75 8.5V6.5C6.75 6.08579 6.41421 5.75 6 5.75C5.58579 5.75 5.25 6.08579 5.25 6.5L5.25 8.5ZM12.75 7.5C12.75 7.08579 13.0858 6.75 13.5 6.75H18C18.4142 6.75 18.75 7.08579 18.75 7.5C18.75 7.91421 18.4142 8.25 18 8.25H13.5C13.0858 8.25 12.75 7.91421 12.75 7.5Z"
      fill={props.color ?? "#1C274C"}
    />
  </svg>
);
